import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="artist-form"
export default class extends Controller {
  static targets = ["appleId", "newAppleArtist", "spotifyUri", "newSpotifyArtist"]

  connect() {
    // Set initial state based on checkbox values
    this.updateAppleField()
    this.updateSpotifyField()
  }

  toggleAppleNew() {
    if (this.newAppleArtistTarget.checked) {
      this.appleIdTarget.value = ""
      this.appleIdTarget.disabled = true
      this.appleIdTarget.placeholder = "Disabled - New Apple Artist selected"
      this.appleIdTarget.classList.add("bg-gray-100")
    } else {
      this.appleIdTarget.disabled = false
      this.appleIdTarget.placeholder = "Enter Apple ID (digits only)"
      this.appleIdTarget.classList.remove("bg-gray-100")
    }
  }

  toggleSpotifyNew() {
    if (this.newSpotifyArtistTarget.checked) {
      this.spotifyUriTarget.value = ""
      this.spotifyUriTarget.disabled = true
      this.spotifyUriTarget.placeholder = "Disabled - New Spotify Artist selected"
      this.spotifyUriTarget.classList.add("bg-gray-100")
    } else {
      this.spotifyUriTarget.disabled = false
      this.spotifyUriTarget.placeholder = "spotify:artist:XXXXX"
      this.spotifyUriTarget.classList.remove("bg-gray-100")
    }
  }

  validateAppleId(event) {
    // Only allow digits
    const value = event.target.value
    const cleanedValue = value.replace(/\D/g, '')
    if (value !== cleanedValue) {
      event.target.value = cleanedValue
    }
  }

  validateSpotifyUri(event) {
    const value = event.target.value
    const spotifyPattern = /^spotify:artist:[a-zA-Z0-9]*$/
    
    // If user is typing and hasn't completed the prefix yet, allow it
    const prefixes = ["s", "sp", "spo", "spot", "spoti", "spotif", "spotify", "spotify:", "spotify:a", "spotify:ar", "spotify:art", "spotify:arti", "spotify:artis", "spotify:artist", "spotify:artist:"]
    if (prefixes.includes(value)) {
      return
    }
    
    // If the value doesn't match the pattern and isn't a valid prefix
    if (!spotifyPattern.test(value) && value !== '') {
      // Check if they're trying to paste or type something invalid
      const lastChar = value[value.length - 1]
      if (value.startsWith('spotify:artist:')) {
        // Only allow alphanumeric after the prefix
        const artistId = value.replace('spotify:artist:', '')
        const cleanedArtistId = artistId.replace(/[^a-zA-Z0-9]/g, '')
        event.target.value = 'spotify:artist:' + cleanedArtistId
      } else if (!value.startsWith('spotify:')) {
        // If they're not starting with spotify:, help them
        event.target.value = 'spotify:artist:'
      }
    }
  }

  updateAppleField() {
    this.toggleAppleNew()
  }

  updateSpotifyField() {
    this.toggleSpotifyNew()
  }
}